import { EventType, EventTypeDetailed, GeoLocation, SortValue } from "@/types";

import { axios } from "../axios.instance";

export type FilterDateNightsOptions = {
  location?: GeoLocation;
  fromDate?: string;
  toDate?: string;
  sortBy?: SortValue;
};

export type GetDateNightsRequest = {
  perPage?: number;
  cursor?: string;
} & FilterDateNightsOptions;

export type GetDateNightsResponse = {
  data: Array<EventType & EventTypeDetailed>;
  meta: {
    hasNextPage: boolean;
    nextCursor?: string;
  };
};

export const getDateNights = async ({ location, ...params }: GetDateNightsRequest): Promise<GetDateNightsResponse> => {
  const { data } = await axios.get(
    `/events/date-nights${location ? `?location=${location.coordinates[1]},${location.coordinates[0]}` : ""}`,
    {
      params,
    }
  );

  return data;
};
